export const viewer = 'viewer';
export const dataLayers = 'dataLayers';
export const drawInfo = 'drawInfo';
export const resultLayers = 'resultLayers';
export const legend = 'legend';
export const print = 'print';
export const project = 'project';
export const sqftCalculator = 'sqft_calculator';
export const propertyInfo = 'property_info';
export const NEW_SKETCHES = 'new_sketches';
export const DRAWN_SKETCHES = 'drawn_sketches';

// deprecated
export const bookmarks = 'bookmarks';
export const newBookmark = 'newBookmark';

// resources
export const bookmark = 'bookmark';
export const SEARCH = 'search_enhanced';
export const search = 'search';
export const sites_analysis = 'sites_analysis';
export const site_card = 'site_card';
export const PLANNING_ALERTS = 'planningAlerts';
export const comparable = 'comparable';
export const LAND_ASSEMBLY = 'landAssembly';
export const OWNERSHIP_SEARCH = 'ownershipSearch';

export const editResource = 'editResource';
